import {GpHoldingListItemReqRes} from './GpHoldingListItem.model';
import {LocationDetailsResponse} from 'src/app/shared/models/LocationDetailsResponse.model';
import {HoldingFileReqRes} from './HoldingFileReqRes.model';
import {LpOwnershipVisibility} from 'src/app/shared/enums/LpOwnershipVisibility.enum';
import OwnershipCalculationType from 'src/app/shared/enums/OwnershipCalculationType.enum';
import {CommitmentsEnabled} from 'src/app/shared/enums/CommitmentsEnabled.enum';

export class GpHolding extends GpHoldingListItemReqRes {
  totalCapitalization: number;
  totalEquityInvestedToDate: number;
  totalReturnsToDate: number;
  totalInvestorEquity: number;
  email: string;

  location: LocationDetailsResponse;
  allowLpSetBank: boolean;
  displayIrr: boolean;
  displayCashOnCash: boolean;
  displayEquityMultiple: boolean;
  displayNetAssetValue: boolean;
  displayShares: boolean;
  includeUnrealizedNav: boolean;
  pricePerShare: number;
  attachments: HoldingFileReqRes[];

  commitmentsEnabled: CommitmentsEnabled;
  ownershipCalculationType: OwnershipCalculationType;
  lpOwnershipVisibility: LpOwnershipVisibility;
  displayCommitments: boolean;
}
